export default __webpack_public_path__ + "static/media/307.10e01678.png";